import React from "react";
import { connect } from "react-redux";
import Section from "../../UI/Section";
import InformerWidget from "../../UI/InformerWidget";
import getMyProfileStat from "../../../_selectors/userSelectors/getMyProfileStat";

const Stats = ({ stat }) => {
  return (
    <Section className="tour-step-three">
      <div className="row">
        <div className="col-md-2 col-xs-6">
          <InformerWidget text={stat.views} description="Profile Views" />
        </div>
        <div className="col-md-2 col-xs-6">
          <InformerWidget warning text={stat.likes} description="Likes" />
        </div>
        <div className="col-md-2 col-xs-6">
          <InformerWidget
            info
            text={stat.interests}
            description="Expressed-Interest"
          />
        </div>
        <div className="col-md-2 col-xs-6">
          <InformerWidget
            success
            text={stat.shortlist}
            description="ShortListed"
          />
        </div>
        <div className="col-md-2 col-xs-6">
          <InformerWidget primary text={stat.saved} description="Saved" />
        </div>
        <div className="col-md-2 col-xs-6">
          <InformerWidget
            danger
            text={stat.favorite}
            description="Added To Favourite"
          />
        </div>
      </div>
    </Section>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stat: getMyProfileStat(state)
});

export default connect(mapStateToProps)(Stats);



// WEBPACK FOOTER //
// ./src/_components/Home/Stats/index.js